import { useSearchParams } from "react-router";
import { QUERY_PARAMS } from "@motain/web-shared-hub/constants";

export const useRedirectUrl = (): string => {
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get(QUERY_PARAMS.redirectUrl) ?? "";

  return redirectUrl ?? "";
};
